import { render, staticRenderFns } from "./ShopOrderUpdate.vue?vue&type=template&id=0c6fd00f&"
import script from "./ShopOrderUpdate.vue?vue&type=script&lang=js&"
export * from "./ShopOrderUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports